import React, { useState, useEffect } from 'react';
import { find } from 'lodash';
import moment from 'moment';

import { getApiAxiosInstance } from '../../../utils/network';
import { getAllClubLocations } from '../../../api/clubLocationsApi';

import HeaderDesktop from './HeaderDesktop';
import HeaderMobile from './HeaderMobile';

import styles from '../dualMatch.scss';
import { isAdultTeamTennisMatch } from '../../../utils/events';

const _ = { find };

const Header = (props) => {
    const {
        auth,
        isAdmin,
        redirectTo,
        event,
        handleScoreChange,
        handleWinnerChange,
        isCollegeDualMatch,
    } = props;

    const {
        eventTeams,
        teamEventScoreDetail,
        eventSchedule,
        eventTours,
        eventLocations,
        matchType,
        eventType,
        published,
    } = event;
    const primaryEventLocation = eventLocations[0];
    const isTeamTennisMatch = isAdultTeamTennisMatch(eventType.value);
    const [clubLocationName, setClubLocationName] = useState(primaryEventLocation?.display);
    useEffect(() => {
        (async () => {
            const homeTeam = eventTeams.find(eventTeam => { return eventTeam.isHome; });
            const { data } = await getAllClubLocations(getApiAxiosInstance(), homeTeam.clubId);
            const eventClubLocation = data.clubLocations.find(l => {
                return l.location.googleFormattedName === primaryEventLocation?.googleFormattedName;
            });
            setClubLocationName(eventClubLocation?.name || primaryEventLocation?.display);
        })();
    }, [eventLocations]);

    const isUserPowered = auth && auth.user && auth.user.isPowered;

    let team1; let team2; let scoreTeam1 = 0; let scoreTeam2 = 0; let isWinnerTeam1 = false; let isWinnerTeam2 = false;
    if (!eventTeams[0].isHome) {
        [team1, team2] = eventTeams;
    } else {
        [team2, team1] = eventTeams;
    }

    if (primaryEventLocation) {
        primaryEventLocation.locationDisplay = `${eventSchedule?.eventStartLong} at ${clubLocationName}, ${team2.name}`;
    }

    if (teamEventScoreDetail && teamEventScoreDetail.scores) {
        const team1scoreObj = _.find(teamEventScoreDetail.scores, { clubId: team1.clubId });
        const team2scoreObj = _.find(teamEventScoreDetail.scores, { clubId: team2.clubId });
        scoreTeam1 = team1scoreObj ? (team1scoreObj.score || 0) : 0;
        scoreTeam2 = team2scoreObj ? (team2scoreObj.score || 0) : 0;
        isWinnerTeam1 = team1scoreObj ? (team1scoreObj.isWinner || false) : false;
        isWinnerTeam2 = team2scoreObj ? (team2scoreObj.isWinner || false) : false;
    }

    const isFutureMatch = moment.utc().isBefore(moment(eventSchedule?.eventStartUtc));
    const displayMatchStatus = !(published && isTeamTennisMatch && scoreTeam1 === 0 && scoreTeam2 === 0 && isFutureMatch);

    const headerProps = {
        auth,
        isAdmin,
        redirectTo,
        isUserPowered,
        team1,
        team2,
        scoreTeam1,
        scoreTeam2,
        isWinnerTeam1,
        isWinnerTeam2,
        eventSchedule,
        eventLocations,
        eventTours,
        handleScoreChange,
        handleWinnerChange,
        matchType,
        isTeamTennisMatch,
        displayMatchStatus,
        isCollegeDualMatch,
    };

    return (
        <div className={styles.header}>
            <div className="container d-md-none pr0 pl0">
                <HeaderMobile
                    {...headerProps}
                />
            </div>
            <div className="container d-none d-md-block">
                <HeaderDesktop
                    {...headerProps}
                />
            </div>
        </div>
    );
};

export default Header;
